// Where a click puts the playhead.
//
// An *event* is worth rewinding for: the lag time exists so a breach can be
// watched from a few seconds before it, and consolidateEvents uses the same
// window to decide what counts as one event. A click on a point of the chart
// is not that — it names an instant, and answering it a few seconds earlier
// means the reading under the cursor is not the one on screen.
export function seekTimeFor(startTime, { lagTime = 0, notBefore } = {}) {
  const target = new Date(startTime).getTime() - lagTime;
  const floor = notBefore === undefined || notBefore === null ? null : new Date(notBefore).getTime();
  if (floor !== null && !Number.isNaN(floor) && target < floor) return new Date(floor);
  return new Date(target);
}

export default seekTimeFor;
